
import { Route } from '@/app/router'

const Clients = () => import('./index.vue')

const ClientMeta = {
	sort: 10,
	displayInSidebar: true,
	displayName: 'client',
	icon: 'fal clipboard-user',
	activeIcon: 'fas clipboard-user'
}

const ClientProps = ['page', 'perPage']

export default new Route('/clients', Clients)
	.as('Dashboard:Clients')
	.meta(ClientMeta)
	.props(ClientProps)
	.permissions(['VIEW_CLIENT'])
